import React from "react";
import { Circle, View, XStack, YStack } from "tamagui";

import { GradientCard, GradientCardProps } from "./GradientCard";
import { SkeletonBox } from "./SkeletonBox";

export interface ChartCardSkeletonProps
  extends Omit<GradientCardProps, "children"> {
  minHeight?: number | string;
}

// Mirrors BorderedCard's shape (title row + content area) — the silhouette
// shared by every Analytics detail card (WaterQuality, HVACFilterStatus,
// EnergySavings, TopLiveElectricalUsage, Humidity, HVACRawData). One generic
// placeholder shape for all of them; the real content area layouts differ,
// but the row/column swap-in happens at ~1 render tick so exact matching
// isn't required. Static only — no animation.
export const ChartCardSkeleton: React.FC<ChartCardSkeletonProps> = ({
  minHeight = "290px",
  ...rest
}) => (
  <View flexGrow={1} flexBasis={0} $lg={{ flexBasis: "100%" }}>
    <GradientCard height="100%" minHeight={minHeight} overflow="hidden" {...rest}>
      <XStack justifyContent="space-between" alignItems="center">
        <SkeletonBox height={16} width="35%" />
      </XStack>
      <YStack flex={1} justifyContent="center" alignItems="center" gap="$3">
        <Circle size={120} backgroundColor="$transparentBorder" opacity={0.6} />
        <SkeletonBox height={14} width="45%" />
      </YStack>
    </GradientCard>
  </View>
);
